import { render, staticRenderFns } from "./OrderWrapper.vue?vue&type=template&id=641a7640&"
import script from "./OrderWrapper.vue?vue&type=script&lang=js&"
export * from "./OrderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports